var doT = require("dot");

const textClass = "detail-text";

function isFullsizeImage() {
  if (!("MonrifPolopolyUtility" in window && "page" in window.MonrifPolopolyUtility)) {
    return
  }
  return window.MonrifPolopolyUtility.page.match(/^monrif\.page\.\w+\.migliori/);
}

var shortcodes = new function shortcodes() {
  var templates = {};
  this.load = function () {
    $("script[type='text/x-shortcode-tmpl']").each(function (i, el) {
      var $el = $(el);
      templates[$el.data("type")] = doT.template($el.html());
    });
  }
  this.expand = function () {
    $("." +  textClass + " [data-shortcode]").each(function (i, el) {
      var $el = $(el);
      var it = $el.data();
      var type = $el.data("type");
      var img = $el.data("img") || "";
      if (isFullsizeImage()) img = img.replace(/wide_680/, "fullsize");
      if (img && typeof img == "string" && img[0] == "/") {
        var hostname = "p1014p.quotidiano.net";
        if ('globals' in window && 'imageOrigin' in window.globals) {
            hostname = window.globals.imageOrigin;
        }
        img = "http://" + hostname + img;
        it.img = img;
      }
      it.title = $el.attr("title") || "";
      if (it.title === "false") it.title = "";
      it.href = $el.attr("href") || "#";
      it.style = $el.attr("style") || "";
      it.autostart = $el.attr("autostart") || "false";
      if (type && type in templates) {
        // inserisce il template e rimuove l'oggetto originale
        $el.before(templates[type](it));
        $el.detach();
      }
    });
  }
}

export { shortcodes };
